<div mat-dialog-title class="flex flex-row">
    Recusa
    <div class="flex-fill"></div>
    <div class="btn-options">
        <button color="primary" (click)="dialogRef.close(update)" mat-icon-button matTooltip="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content>
    <form [formGroup]="form">
        <div class="flex flex-column">
            <mat-form-field>
                <mat-label>Tipo recusa</mat-label>
                <mat-select formControlName="tipoRecusa">
                    <mat-option [value]="1"> R.G. não atualizado. Providenciar R.G atualizado com menos de 10 anos de emissão.  </mat-option>
                    <mat-option [value]="2"> Documento não legível ou incompleto. Providenciar documento que esteja legível, completo, frente e verso sem cortes </mat-option>
                    <mat-option [value]="3"> Histórico ou certificado de conclusão do ensino fundamental falta a publicação em Diário Oficial ou publicação no sistema GDAE/SED.  </mat-option>
                    <mat-option [value]="4"> Histórico ou certificado de conclusão do ensino fundamental falta autenticação em cartório. Providenciar autenticação do documento em cartório.  </mat-option>
                    <mat-option [value]="5"> O comprovante de endereço apresentado não possui o CEP. Providenciar comprovante de endereço com CEP.  </mat-option>
                    <mat-option [value]="6"> Documentos apresentados possuem divergência nas informações.  </mat-option>
                    <mat-option [value]="7"> Documento apresentado não aceito para comprovação de alfabetização. Providenciar documento que seja aceito para comprovação de alfabetização.  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="flex-fill">
                <mat-label>Mensagem</mat-label>
                <input formControlName="mensagem" matInput/>
            </mat-form-field>
        </div>
        <div class="btn-options">
            <button type="button" (click)="save()" color="primary" mat-button>
                Recusar
            </button>
        </div>
    </form>
    <mat-progress-bar *ngIf="enviando" mode="indeterminate" color="primary"></mat-progress-bar>
</div>

<ng-template #errorTemplate>
    <app-server-error></app-server-error>
</ng-template>

<ng-template #loading>
    <mat-spinner [diameter]="25"></mat-spinner>
</ng-template>